//请自行添加语言资源
const area = {
  provinceCode: '行政编码(省)',
  provinceName: '省',
  cityCode: '行政编码(市)',
  cityName: '市',
  distrinctCode: '行政编码(区)',
  distrinctName: '区',
};
export default area



// WEBPACK FOOTER //
// ./src/page/mdm/area/lang/area.zh.js